import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type Props = {
  imEvent: ImEventDto;
};

export const PriceRow: React.FC<Props> = ({ imEvent: { price } }) => {
  const shouldShowPrice = () => {
    return price === 'free';
  };
  return (
    <>
      {shouldShowPrice() && (
        <TableRow>
          <TableCell>料金</TableCell>
          <TableCell>
            {price === 'free' && '無料'}
            {/* 以下は表示されないはず */}
            {price === 'paid' && '有料'}
            {price === 'unknown' && '参照URLを確認ください'}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};
